import { useNavigate } from "react-router-dom";
import { CompanionView } from "../components/companion-view.js";

/*
 * /companion — the AI personal chat surface. CompanionView is a full
 * screen experience; exiting returns to Home.
 */
export const Companion = () => {
  const navigate = useNavigate();
  return <CompanionView onExit={() => navigate("/home")} />;
};
